// src/defs/playback-state.ts
var PlaybackState = /* @__PURE__ */ ((PlaybackState2) => {
  PlaybackState2["Idle"] = "idle";
  PlaybackState2["Playing"] = "playing";
  PlaybackState2["Paused"] = "paused";
  PlaybackState2["Broken"] = "broken";
  return PlaybackState2;
})(PlaybackState || {});
var WaitingReason = /* @__PURE__ */ ((WaitingReason2) => {
  WaitingReason2["Starting"] = "starting";
  WaitingReason2["Seeking"] = "seeking";
  WaitingReason2["Rebuffering"] = "rebuffering";
  return WaitingReason2;
})(WaitingReason || {});
var PausedReason = /* @__PURE__ */ ((PausedReason2) => {
  PausedReason2["AutoplayBlocked"] = "autoplayblocked";
  PausedReason2["Ended"] = "ended";
  return PausedReason2;
})(PausedReason || {});

// src/events/event.ts
var CoreEvent = /* @__PURE__ */ ((CoreEvent2) => {
  CoreEvent2["SessionCreated"] = "playercore.sessioncreated";
  CoreEvent2["SessionClosed"] = "playercore.sessionclosed";
  CoreEvent2["PlayingChange"] = "playercore.playingchange";
  CoreEvent2["WaitingChange"] = "playercore.waitingchange";
  CoreEvent2["TimeRunningChange"] = "playercore.timerunningchange";
  CoreEvent2["Broken"] = "playercore.broken";
  CoreEvent2["MediaInfoLoaded"] = "playercore.mediainfoloaded";
  CoreEvent2["LiveStreamEnded"] = "playercore.livestreamended";
  CoreEvent2["RateChange"] = "playercore.ratechange";
  CoreEvent2["VolumeChange"] = "playercore.volumechange";
  CoreEvent2["MutedChange"] = "playercore.mutedchange";
  CoreEvent2["TimeUpdate"] = "playercore.timeupdate";
  CoreEvent2["ScrubberUpdate"] = "playercore.scrubberupdate";
  CoreEvent2["MediaRangeChange"] = "playercore.mediarangechange";
  CoreEvent2["QualityChange"] = "playercore.qualitychange";
  CoreEvent2["FullscreenStateChange"] = "playercore.fullscreenstatechange";
  CoreEvent2["PiPStateChange"] = "playercore.pipstatechange";
  CoreEvent2["RemotePlaybackStateChange"] = "playercore.remoteplaybackstatechange";
  CoreEvent2["SubtitlesChange"] = "playercore.subtitleschange";
  CoreEvent2["SubtitlesDisplayChange"] = "playercore.subtitlesdisplaychange";
  CoreEvent2["SubtitlesCueUpdate"] = "playercore.subtitlescueupdate";
  return CoreEvent2;
})(CoreEvent || {});
var PlayingChangeType = /* @__PURE__ */ ((PlayingChangeType2) => {
  PlayingChangeType2["Starting"] = "starting";
  PlayingChangeType2["Replay"] = "replay";
  return PlayingChangeType2;
})(PlayingChangeType || {});

export {
  PlaybackState,
  WaitingReason,
  PausedReason,
  CoreEvent,
  PlayingChangeType
};
